import { CMDTableContainer } from "#/components/views/reimbursements/educationmodal/CMDTable"
import { DeductibleInfoMessage } from "#/components/views/reimbursements/educationmodal/DeductibleInfoMessage"
import { DialogTitle, Stack, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"

export const CarrotDeductibleInformational = ({ hasCostShare }: { hasCostShare: boolean }): JSX.Element => {
  return (
    <Stack display="flex" gap={(theme) => theme.tokens.spacing.lg}>
      <DialogTitle id="deductible-modal-header">
        <FormattedMessage defaultMessage="About your deductible" />
      </DialogTitle>
      <DeductibleInfoMessage />
      <Typography>
        {hasCostShare ? (
          <FormattedMessage defaultMessage="Carrot funds you use may also be subject to bank fees, taxes, cost sharing, and other plan details." />
        ) : (
          <FormattedMessage defaultMessage="Carrot funds you use may also be subject to bank fees, taxes, and other plan details." />
        )}
      </Typography>
      <CMDTableContainer />
    </Stack>
  )
}
